var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "time-line" },
    [
      _c(
        "div",
        {
          staticClass: "section",
          style: "padding-left:" + _vm.timeLines.time_width + "px",
        },
        [
          _c(
            "ul",
            _vm._l(_vm.course, function (item, index) {
              return _c(
                "li",
                { key: index, staticStyle: { "list-style": "none" } },
                [
                  (
                    index - 1 >= 0
                      ? item.createDate.substring(0, 10) !==
                          _vm.course[index - 1].createDate.substring(0, 10) &&
                        _vm.timeLines.time_type == "log"
                      : true && _vm.timeLines.time_type == "log"
                  )
                    ? _c(
                        "div",
                        {
                          staticClass: "timeWeek",
                          style: index == 0 ? "border:none" : "",
                        },
                        [
                          _vm._v(
                            " " + _vm._s(item.createDate.substring(0, 10)) + " "
                          ),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "24px" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.week[new Date(item.createDate).getDay()]
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          (
                            index <= _vm.course.length - 2 &&
                            item.createDate.substring(0, 10) ===
                              _vm.course[index + 1].createDate.substring(0, 10)
                              ? true
                              : false
                          )
                            ? _c("div", {
                                staticClass: "line",
                                staticStyle: {
                                  top: "95px",
                                  height: "calc(100% - 90px)",
                                },
                              })
                            : _vm._e(),
                        ]
                      )
                    : _vm.timeLines.time_type == "log"
                    ? _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              index <= _vm.course.length - 2 &&
                              item.createDate.substring(0, 10) ===
                                _vm.course[index + 1].createDate.substring(
                                  0,
                                  10
                                ),
                            expression:
                              "index<=course.length-2&&(item.createDate).substring(0,10)===(course[index+1].createDate).substring(0,10)",
                          },
                        ],
                        staticClass: "line",
                      })
                    : _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: index != _vm.course.length - 1,
                            expression: "index!=course.length-1",
                          },
                        ],
                        staticClass: "line",
                      }),
                  _vm.timeLines.time_type == "card"
                    ? _c("div", { staticClass: "item-wrapper" }, [
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: index != 0,
                              expression: "index != 0",
                            },
                          ],
                          staticClass: "circle",
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: index === 0,
                                expression: "index === 0",
                              },
                            ],
                            staticClass: "circles",
                          },
                          [_c("div", { staticClass: "circle1" })]
                        ),
                        _c("div", { staticClass: "title_time" }, [
                          _c(
                            "h6",
                            {
                              staticClass: "title",
                              staticStyle: { color: "#2878ff" },
                            },
                            [_vm._v(_vm._s(item.releaseNumber))]
                          ),
                          _c("h6", { staticClass: "time" }, [
                            _vm._v(_vm._s(item.updateDate.substring(0, 10))),
                          ]),
                        ]),
                        _c("div", { staticClass: "item-content" }, [
                          _c("div", { staticClass: "desc_title" }, [
                            _vm._v(_vm._s(item.title)),
                          ]),
                          _c(
                            "div",
                            { staticStyle: { "white-space": "pre-wrap" } },
                            [
                              item.content
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "desc",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          item.content.replace(/\\n/g, "<br/>")
                                        ),
                                      },
                                    },
                                    [_vm._v(_vm._s(item.content))]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ])
                    : _c("div", [
                        _vm.timeLines.time_type == "log"
                          ? _c("div", [
                              _c("div", { staticClass: "tab-wrapper" }, [
                                _c("div", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: index != 0,
                                      expression: "index != 0",
                                    },
                                  ],
                                  staticClass: "circle",
                                }),
                                _c("div", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: index === 0,
                                      expression: "index === 0",
                                    },
                                  ],
                                  staticClass: "circles",
                                }),
                                _c("div", { staticClass: "title_time" }, [
                                  _c("div", [
                                    _c("h6", { staticClass: "time" }, [
                                      _vm._v(
                                        _vm._s(
                                          item.createDate.substring(10, 16)
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c("div", { staticClass: "item-content" }, [
                                  item.operator.avatar != ""
                                    ? _c("img", {
                                        staticClass: "info_personnel_surname",
                                        attrs: { src: item.operator.avatar },
                                      })
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "info_personnel_surname",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.operator.name.substring(0, 1)
                                            )
                                          ),
                                        ]
                                      ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "calc(100% - 36px)",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "content_names" },
                                        [
                                          _vm.channel === "wechat"
                                            ? _c(
                                                "span",
                                                [
                                                  _c("ww-open-data", {
                                                    attrs: {
                                                      type: "userName",
                                                      openid:
                                                        item.operator.name,
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(item.operator.name)
                                                ),
                                              ]),
                                          _c(
                                            "div",
                                            { staticClass: "content_desc" },
                                            [_vm._v(_vm._s(item.title))]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "content_desc" },
                                        [_vm._v(_vm._s(item.content))]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "file_list" },
                                        [
                                          _vm._l(
                                            item.files,
                                            function (file, index1) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index1,
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.previewFile(
                                                        item,
                                                        index1
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  file.screenshot === "1"
                                                    ? _c("div", [
                                                        _c("img", {
                                                          staticStyle: {
                                                            "max-width":
                                                              "200px",
                                                            "max-height":
                                                              "100px",
                                                          },
                                                          attrs: {
                                                            src: file.absoUrl,
                                                            alt: "",
                                                          },
                                                        }),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              )
                                            }
                                          ),
                                          _vm._l(
                                            item.files,
                                            function (file, index1) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index1,
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.previewFile(
                                                        item,
                                                        index1
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  file.screenshot !== "1"
                                                    ? _c("div", [
                                                        _c("i", {
                                                          staticClass:
                                                            "iconfont icon-wenjian file__icon",
                                                        }),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              file.fileName
                                                            )
                                                          ),
                                                        ]),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ])
                          : _c("div", { staticClass: "tab-wrapper" }, [
                              _c("div", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: index != 0,
                                    expression: "index != 0",
                                  },
                                ],
                                staticClass: "circle",
                              }),
                              _c("div", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: index === 0,
                                    expression: "index === 0",
                                  },
                                ],
                                staticClass: "circles",
                              }),
                              _c("div", { staticClass: "title_time" }, [
                                _c("div", [
                                  _c(
                                    "h6",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            index - 1 >= 0
                                              ? item.createDate.substring(
                                                  0,
                                                  10
                                                ) !==
                                                _vm.course[
                                                  index - 1
                                                ].createDate.substring(0, 10)
                                              : true,
                                          expression:
                                            "index-1>=0?(item.createDate).substring(0,10)!==(course[index-1].createDate).substring(0,10):true",
                                        },
                                      ],
                                      staticClass: "time",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(item.createDate.substring(0, 10))
                                      ),
                                    ]
                                  ),
                                  _c("h4", { staticClass: "time" }, [
                                    _vm._v(
                                      _vm._s(item.createDate.substring(10, 16))
                                    ),
                                  ]),
                                ]),
                              ]),
                              _c("div", { staticClass: "item-content" }, [
                                item.createUser.avatar != ""
                                  ? _c("img", {
                                      staticClass: "info_personnel_surname",
                                      attrs: { src: item.createUser.avatar },
                                    })
                                  : _c(
                                      "div",
                                      { staticClass: "info_personnel_surname" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.createUser.name.substring(0, 1)
                                          )
                                        ),
                                      ]
                                    ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: { width: "calc(100% - 36px)" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "content_names" },
                                      [
                                        _vm.channel === "wechat"
                                          ? _c(
                                              "span",
                                              [
                                                _c("ww-open-data", {
                                                  attrs: {
                                                    type: "userName",
                                                    openid:
                                                      item.createUser.name,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(item.createUser.name)
                                              ),
                                            ]),
                                        _c(
                                          "div",
                                          { staticClass: "content_desc" },
                                          [_vm._v(_vm._s(item.title))]
                                        ),
                                      ]
                                    ),
                                    item.content
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "content_desc",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                item.content.replace(
                                                  /\n/g,
                                                  "<br/>"
                                                )
                                              ),
                                            },
                                          },
                                          [_vm._v(_vm._s(item.content))]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      { staticClass: "file_list" },
                                      [
                                        _vm._l(
                                          item.files,
                                          function (file, index1) {
                                            return _c(
                                              "div",
                                              {
                                                key: index1,
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.previewFile(
                                                      item,
                                                      index1
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                file.screenshot === "1"
                                                  ? _c("div", [
                                                      _c("img", {
                                                        staticStyle: {
                                                          "max-width": "200px",
                                                          "max-height": "100px",
                                                        },
                                                        attrs: {
                                                          src: file.absoUrl,
                                                          alt: "",
                                                        },
                                                      }),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            )
                                          }
                                        ),
                                        _vm._l(
                                          item.files,
                                          function (file, index1) {
                                            return _c(
                                              "div",
                                              {
                                                key: index1,
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.previewFile(
                                                      item,
                                                      index1
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                file.screenshot !== "1"
                                                  ? _c("div", [
                                                      _c("i", {
                                                        staticClass:
                                                          "iconfont icon-wenjian file__icon",
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(file.fileName)
                                                        ),
                                                      ]),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                      ]),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _c("VideoPreview", {
        attrs: { visible: _vm.showVideo, url: _vm.videoUrl },
        on: {
          "update:visible": [
            function ($event) {
              _vm.showVideo = $event
            },
            function (val) {
              return _vm.console.log("visible 更新为:", val)
            },
          ],
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }